"use client";

import React from "react";

export default function PoliticaDeRetur() {
    return (
        <div className="privacy-wrapper">
            <style jsx>{`
                .privacy-wrapper {
                    background-color: #f5f7fa;
                    min-height: 100vh;
                    display: flex;
                    justify-content: center;
                    align-items: flex-start;
                    padding: 60px 20px;
                    font-family: "Inter", Arial, sans-serif;
                    color: #333;
                }
                .privacy-container {
                    background: #fff;
                    max-width: 900px;
                    width: 100%;
                    padding: 50px 60px;
                    border-radius: 16px;
                    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
                }
                .privacy-title {
                    font-size: 32px;
                    font-weight: 800;
                    margin-bottom: 8px;
                    color: #111;
                }
                .privacy-subtitle {
                    font-size: 14px;
                    color: #888;
                    margin-bottom: 40px;
                }
                .section {
                    margin-bottom: 36px;
                }
                .section-title {
                    font-size: 18px;
                    font-weight: 700;
                    color: #111;
                    margin-bottom: 12px;
                    padding-bottom: 8px;
                    border-bottom: 2px solid #f0f0f0;
                }
                p {
                    font-size: 15px;
                    line-height: 1.8;
                    color: #444;
                    margin-bottom: 12px;
                }
                ul {
                    padding-left: 20px;
                    margin-bottom: 12px;
                }
                ul li {
                    font-size: 15px;
                    line-height: 1.8;
                    color: #444;
                    margin-bottom: 6px;
                }
                .highlight-box {
                    background: #f0f9ff;
                    border-left: 4px solid #3b82f6;
                    border-radius: 8px;
                    padding: 16px 20px;
                    margin-bottom: 16px;
                    font-size: 15px;
                    color: #0c4a6e;
                    line-height: 1.7;
                }
                .warning-box {
                    background: #fff7ed;
                    border-left: 4px solid #f59e0b;
                    border-radius: 8px;
                    padding: 16px 20px;
                    margin-bottom: 16px;
                    font-size: 15px;
                    color: #78350f;
                    line-height: 1.7;
                }
                .cta-box {
                    background: #f8f9fa;
                    border-radius: 12px;
                    padding: 24px 28px;
                    text-align: center;
                    margin-top: 20px;
                }
                .cta-box a {
                    display: inline-block;
                    background: #000;
                    color: #fff;
                    padding: 13px 32px;
                    border-radius: 8px;
                    text-decoration: none;
                    font-weight: 700;
                    font-size: 15px;
                    margin-top: 12px;
                }
                @media (max-width: 768px) {
                    .privacy-container {
                        padding: 32px 24px;
                    }
                    .privacy-title {
                        font-size: 24px;
                    }
                }
            `}</style>

            <div className="privacy-container">
                <h1 className="privacy-title">Politica de Retur și Returnare</h1>
                <p className="privacy-subtitle">
                    Ultima actualizare: Mai 2025 · NEGRU ADRIAN PERSOANA FIZICA AUTORIZATA · CUI RO34610550
                </p>

                <div className="highlight-box">
                    Conform <strong>Ordonanței de Urgență nr. 34/2014</strong> privind drepturile consumatorilor în cadrul contractelor încheiate cu profesioniștii, aveți dreptul de a returna produsele achiziționate online în termen de <strong>14 zile calendaristice</strong> de la data primirii coletului, fără a fi necesar să oferiți o justificare.
                </div>

                <div className="section">
                    <h2 className="section-title">1. Dreptul de retragere</h2>
                    <p>
                        Aveți dreptul de a vă retrage din contract în termen de <strong>14 zile calendaristice</strong> de la data la care dvs. sau o parte terță indicată de dvs. (alta decât transportatorul) intră în posesia fizică a produsului.
                    </p>
                    <p>
                        În cazul în care ați comandat mai multe produse printr-o singură comandă și acestea sunt livrate separat, termenul de 14 zile curge de la data la care intrați în posesia fizică a ultimului produs.
                    </p>
                    <p>
                        Pentru a vă exercita dreptul de retragere, trebuie să ne notificați decizia dvs. printr-o declarație neechivocă, folosind formularul de retur disponibil pe site.
                    </p>
                </div>

                <div className="section">
                    <h2 className="section-title">2. Condiții pentru retur</h2>
                    <p>Produsele pot fi returnate dacă îndeplinesc <strong>cumulativ</strong> următoarele condiții:</p>
                    <ul>
                        <li>Se află în starea originală — nefolosite, nedeterioriate și cu toate accesoriile incluse</li>
                        <li>Au etichetele și ambalajul original intact</li>
                        <li>Nu au fost modificate, personalizate sau adaptate la cererea clientului</li>
                        <li>Sunt însoțite de documentul de achiziție (factură sau bon fiscal)</li>
                        <li>Cererea de retur este transmisă în termenul legal de 14 zile</li>
                    </ul>

                    <div className="warning-box">
                        <strong>Produse exceptate de la dreptul de retragere</strong> (conform art. 16 din OUG 34/2014):
                        <ul style={{ marginTop: 8, marginBottom: 0 }}>
                            <li>Produse confecționate după specificațiile consumatorului sau personalizate</li>
                            <li>Produse sigilate care nu pot fi returnate din motive de protecție a sănătății sau igienă, dacă au fost desigilate după livrare</li>
                            <li>Produse care au fost amestecate în mod ireversibil cu alte produse după livrare</li>
                        </ul>
                    </div>
                </div>

                <div className="section">
                    <h2 className="section-title">3. Cum se face returul</h2>
                    <p><strong>Pasul 1 —</strong> Completați formularul de retur de pe site în termen de 14 zile de la primirea coletului.</p>
                    <p><strong>Pasul 2 —</strong> Veți fi contactat de echipa noastră în maxim 2 zile lucrătoare cu instrucțiunile de returnare.</p>
                    <p><strong>Pasul 3 —</strong> Expediați produsul la adresa indicată sau, dacă ați solicitat ridicare de la adresă, un curier va fi programat.</p>
                    <p><strong>Pasul 4 —</strong> După recepționarea și verificarea produsului, rambursarea se procesează în maxim <strong>14 zile calendaristice</strong>.</p>

                    <div className="highlight-box">
                        <strong>Adresă retur:</strong> Str. Alexandru Sahia, Nr. 15, Cugir, România<br />
                        <strong>Email:</strong> contact@adi-mag.ro<br />
                        <strong>Telefon:</strong> +40 760 111 051
                    </div>
                </div>

                <div className="section">
                    <h2 className="section-title">4. Costurile de retur</h2>
                    <p>
                        Costurile directe de returnare a produsului sunt suportate de <strong>client</strong>, cu excepția cazurilor în care:
                    </p>
                    <ul>
                        <li>Produsul a sosit defect sau deteriorat din vina transportatorului</li>
                        <li>Produsul livrat nu corespunde comenzii plasate (produs greșit)</li>
                        <li>Produsul prezintă un viciu de conformitate</li>
                    </ul>
                    <p>
                        În cazurile de mai sus, costul transportului de retur va fi suportat integral de <strong>NEGRU ADRIAN PERSOANA FIZICA AUTORIZATA</strong>.
                    </p>
                </div>

                <div className="section">
                    <h2 className="section-title">5. Rambursarea sumelor</h2>
                    <p>
                        Rambursarea se efectuează în maxim <strong>14 zile calendaristice</strong> de la data la care am luat cunoștință de decizia dvs. de retragere din contract. Rambursarea poate fi amânată până la primirea produselor sau până la primirea dovezii că produsele au fost trimise înapoi.
                    </p>
                    <p>Rambursarea se face prin:</p>
                    <ul>
                        <li><strong>Transfer bancar (IBAN)</strong> — în contul indicat în formularul de retur</li>
                        <li><strong>Voucher de reducere</strong> — utilizabil pe viitoarele comenzi de pe adi-mag.ro</li>
                    </ul>
                    <p>
                        Suma rambursată include prețul produsului și, dacă este cazul, costul inițial de livrare (costul standard, nu costul suplimentar dacă ați ales o metodă de livrare mai rapidă).
                    </p>
                </div>

                <div className="section">
                    <h2 className="section-title">6. Garanție și produse defecte</h2>
                    <p>
                        Toate produsele comercializate pe adi-mag.ro beneficiază de garanție legală de conformitate de <strong>2 ani</strong> de la data livrării, conform Legii nr. 449/2003 privind vânzarea produselor și garanțiile asociate acestora.
                    </p>
                    <p>
                        În cazul în care produsul prezintă un defect de fabricație sau o neconformitate, aveți dreptul la:
                    </p>
                    <ul>
                        <li>Repararea produsului (dacă este posibilă)</li>
                        <li>Înlocuirea produsului cu unul identic sau echivalent</li>
                        <li>Reducerea prețului</li>
                        <li>Rezoluțiunea contractului și rambursarea integrală</li>
                    </ul>
                </div>

                <div className="section">
                    <h2 className="section-title">7. Contact și reclamații</h2>
                    <p>
                        Pentru orice nelămuriri legate de retururi, garanții sau reclamații, ne puteți contacta:
                    </p>
                    <ul>
                        <li><strong>Email:</strong> contact@adi-mag.ro</li>
                        <li><strong>Telefon:</strong> +40 760 111 051</li>
                        <li><strong>Adresă:</strong> Str. Alexandru Sahia, Nr. 15, Cugir, CUI RO34610550</li>
                    </ul>
                    <p>
                        De asemenea, aveți dreptul de a sesiza <strong>Autoritatea Națională pentru Protecția Consumatorilor (ANPC)</strong> sau de a utiliza platforma europeană de soluționare online a litigiilor (SOL).
                    </p>
                </div>

                <div className="cta-box">
                    <p style={{ margin: 0, fontWeight: 600, fontSize: 16, color: "#111" }}>
                        Doriți să inițiați un retur?
                    </p>
                    <p style={{ margin: "8px 0 0", color: "#666", fontSize: 14 }}>
                        Completați formularul online — vă răspundem în maxim 2 zile lucrătoare.
                    </p>
                    <a href="/formular-retur">Completează formularul de retur →</a>
                </div>
            </div>
        </div>
    );
}
